import React from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../AppContext';
import './Footer.css';

const Footer = () => {
  const { settings: s, footerData: fd } = useAppData();
  const phone   = s?.phone    || '+91 XXXX XXXX XX';
  const email   = s?.email    || 'info@zinga.johngalt.in';
  const address = s?.hqAddress || 'Badlapur, Maharashtra, India';
  const hours   = s?.businessHours || 'Mon – Sat: 9 AM – 6 PM IST';
  const desc    = fd?.companyDesc || 'ZINGA® is an anti-corrosive, single-component, high-performance metallic coating with 96% zinc in dry film. Authorised All India Distributor of ZingaMetall BvBa.';
  const copyright = fd?.copyrightName || 'John Galt Zinga Technologies';
  const ext1Label = fd?.extLink1Label || 'John Galt International';
  const ext1Url   = fd?.extLink1Url   || 'https://www.johngalt.in';
  const ext2Label = fd?.extLink2Label || 'ZingaMetall BvBa';
  const ext2Url   = fd?.extLink2Url   || 'https://www.zinga.be';
  const showQuickLinks = fd?.showQuickLinks !== false;
  const showProducts   = fd?.showProducts   !== false;

  return (
  <footer className="footer">
    <div className="footer-main">
      <div className="footer-container">

        {/* Brand */}
        <div className="footer-col footer-brand">
          <div className="footer-logo">
            <span className="footer-logo-z">Z</span>
            <span className="footer-logo-name">ZINGA</span>
          </div>
          <p className="footer-desc">{desc}</p>
          <p className="footer-address">
            {address}
          </p>
        </div>

        {/* Quick Links */}
        {showQuickLinks && (
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/gem-portal">GeM Portal</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        )}

        {/* Products */}
        {showProducts && (
          <div className="footer-col">
            <h4 className="footer-col-title">Products</h4>
            <ul className="footer-links">
              <li><Link to="/products">Zinga</Link></li>
              <li><Link to="/products">Zingalu</Link></li>
              <li><Link to="/products">AquaZinga</Link></li>
              <li><Link to="/products">Zinga Tarfree</Link></li>
              <li><Link to="/products">Zinga Spray</Link></li>
            </ul>
          </div>
        )}

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-col-title">Contact Us</h4>
          <ul className="footer-contact-list">
            <li>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {address}
            </li>
            <li>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              {phone}
            </li>
            <li>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              {email}
            </li>
            <li>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              {hours}
            </li>
          </ul>
        </div>

      </div>
    </div>

    <div className="footer-bottom">
      <div className="footer-container footer-bottom-inner">
        <p className="footer-copy">&copy; {new Date().getFullYear()} {copyright}. All rights reserved. &nbsp;|&nbsp; Designed by Divanshu Khanna</p>
        <div className="footer-bottom-links">
          {ext1Label && ext1Url && <a href={ext1Url} target="_blank" rel="noopener noreferrer">{ext1Label}</a>}
          {ext2Label && ext2Url && <a href={ext2Url} target="_blank" rel="noopener noreferrer">{ext2Label}</a>}
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
